export const OFFLINE_MEDIA_PREFIX = 'TLL://';
